import {
  IMeterReading,
  MeterReadingMappedStatus,
  MeterReadingStatus,
  SubmissionValue,
  DebugData,
} from "@/models/operations/meterReading/meterReading.types"
import { Status, StatusType } from "@/types/Status"
import { capitalize } from "lodash-es"
import { Dayjs } from "dayjs"
import { TableLink } from "@/types/TableCell"

export class MeterReading implements IMeterReading {
  constructor(
    public id: number,
    public createdAt: Dayjs,
    public status: MeterReadingStatus,
    public submissionValues: SubmissionValue[],
    public debugData: DebugData[] | null,
    public comment: string | null,
    public accountNumber: string | null,
    public userEmail?: string,
    public meterpointIdentifier?: string,
    public errorCode1?: string | null,
  ) {}

  get mappedSubmissionValues(): Record<string, string> | {} {
    const isMultiRate =
      this.submissionValues.length > 1 &&
      this.submissionValues.some((value) => value.type === "Day")
    // add elec title
    const title = isMultiRate ? { Electricity: "" } : {}
    return this.submissionValues.reduce((acc, { type, meterType, value }) => {
      const fuelName = !meterType || isMultiRate ? type : meterType
      return {
        ...acc,
        [fuelName]: value.toString(),
      }
    }, title)
  }

  get accountPath(): TableLink | null {
    if (!this.accountNumber) return null

    return {
      text: this.accountNumber,
      path: `/customer/${this.accountNumber}`,
    }
  }

  get mappedStatus(): MeterReadingMappedStatus {
    let type: StatusType = "default"
    if (this.status === "ERRORED") type = "critical"
    if (this.status === "MANUAL_SUBMISSION") type = "normal"
    if (this.status === "CONTACTED") type = "caution"

    const formatStatus = this.status.split("_").join(" ")

    return {
      value: this.status,
      props: {
        status: new Status(type, capitalize(formatStatus)),
      },
    }
  }

  get errorCodes(): string {
    if (this.debugData) {
      return this.debugData
        .map((data) => data.errorCode)
        .filter((errorCode) => errorCode)
        .join(" - ")
    } else {
      return "no error reason found"
    }
  }
}
